import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW9011Component } from './kymw9011.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PasswordResetService } from './api-services/password-reset.service';

/**
 * 2要素認証画面 モジュール設定クラス
 *
 * @export KYMW9011Module
 * @class KYMW9011Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    FontAwesomeModule
  ],
  declarations: [
    KYMW9011Component,
  ],
  providers: [
    PasswordResetService
  ]
})
export class KYMW9011Module {

}
